'use client';

import { useTranslations } from 'next-intl';
import type { ParallelAgentBatchSummary } from './parallel-agent-batch';

export function useParallelAgentBatchCopy({
  summary,
  memberCount,
}: {
  summary: ParallelAgentBatchSummary;
  memberCount: number;
}): { headline: string; issues: string | undefined } {
  const t = useTranslations('designSystem.chat.parallelAgents');
  const issues = [
    summary.errorCount > 0
      ? t('parallelAgentsFailed', { count: summary.errorCount })
      : undefined,
    summary.abortedCount > 0
      ? t('parallelAgentsStopped', { count: summary.abortedCount })
      : undefined,
  ].filter((note): note is string => !!note);

  return {
    headline: summary.isFinished
      ? t('parallelAgentsFinished', { count: memberCount })
      : t('parallelAgentsRunning', { count: summary.aliveCount }),
    issues: issues.length > 0 ? issues.join(' · ') : undefined,
  };
}
